import { Component, OnInit } from '@angular/core';
import { Subject, timer } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

export class IdleDialog {
  public countDown;
  public onClose = new Subject();
  public onLogout = new Subject();
  public count = 0;
  private worker: Worker;

  constructor(countDown) {
    this.countDown = countDown;
    this.startCountDown();
  }

  public startCountDown() {
    if (typeof Worker !== 'undefined') {
      this.worker = new Worker(new URL('@lib/app.worker', import.meta.url), { type: 'module' });
      this.worker.onmessage = ({ data }) => {
        this.count = data;
        this.checkForLogout();
      };
      this.worker.postMessage('INIT_COUNT');
    } else {
      const numbers = timer(0, 1000);
      numbers.pipe(takeUntil(this.onClose)).subscribe((x) => {
        this.count = x;
        this.checkForLogout();
      });
    }
  }

  checkForLogout() {
    if (this.count === this.countDown) {
      this.worker.postMessage('DESTROY_COUNT');
      setTimeout(() => {
        this.logout();
      });
    }
  }

  close(value?) {
    this.worker.postMessage('DESTROY_COUNT');
    this.onClose.next(value || null);
  }

  logout() {
    this.onLogout.next(true);
  }
}

@Component({
  selector: 'app-idle-dialog',
  templateUrl: './idle-dialog.component.html',
  styleUrls: ['./idle-dialog.component.scss']
})
export class IdleDialogComponent implements OnInit {
  public modalVisible = false;
  public instance: IdleDialog;

  constructor() {}

  ngOnInit() {}

  public show(config: any) {
    if (this.instance) {
      this.instance.onClose.complete();
      delete this.instance;
    }
    this.modalVisible = true;
    this.instance = new IdleDialog(config);
    return this.instance;
  }

  public close(value?: any) {
    this.modalVisible = false;
    this.instance.close(value);
  }
}
